var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[(_vm.prefix + "-badge"), { 'has-dot': _vm.dot }]},[(_vm.dot)?_c('span',{class:[(_vm.prefix + "-badge-dot")]}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }